import { jwtDecode } from "jwt-decode"

export const setToken = token => {
  if (token) {
    localStorage.setItem("token", token)
  } else {
    localStorage.removeItem("token")
  }
}

export const getToken = () => localStorage.getItem("token")
export const removeToken = () => localStorage.removeItem("token")

export const isValidJWT = token => {
  if (!token) return false

  try {
    const decoded = jwtDecode(token)
    const currentTime = Date.now() / 1000

    if (decoded.exp && decoded.exp > currentTime) {
      return true
    }
  } catch (error) {
    return false
  }

  return false
}

export const getUserFromToken = token => {
  if (!token) return null

  try {
    const decoded = jwtDecode(token)

    return decoded
  } catch (error) {
    return null
  }
}
